<template>
  <form @submit.prevent="validateBeforeSubmit">
    <div class="modal-card" style="">
      <header class="modal-card-head">
        <p class="modal-card-title">{{$t('checkout.title')}}</p>
      </header>
      <section class="modal-card-body">
        <b-field
          :label="$t('checkout.client_name')"
          :type="{'is-danger': errors.has('client_name')}"
          :message="[
            errors.firstByRule('client_name', 'required') ? $t('validate.required') : null,
          ]">
          <b-input
            name="client_name"
            :placeholder="$t('checkout.client_name_placeholder')"
            icon="address-card"
            v-validate="'required'"
            v-model="model.client_name">
          </b-input>
        </b-field>
        <b-field
          :label="$t('checkout.email')"
          :type="{'is-danger': errors.has('client_email')}"
          :message="[
            errors.firstByRule('client_email', 'required') ? $t('validate.required') : null,
            errors.firstByRule('client_email', 'email') ? $t('validate.email_validate') : null
          ]">
            <b-input
              name="client_email"
              :placeholder="$t('checkout.email_placeholder')"
              type="email"
              icon="at"
              v-validate="'required|email'"
              v-model="model.client_email">
            </b-input>
        </b-field>
        <b-field 
          :label="$t('checkout.phone')"
          :type="{'is-danger': errors.has('client_phone')}"
          :message="[
            errors.firstByRule('client_name', 'required') ? $t('validate.required') : null,
            errors.firstByRule('client_name', 'min') ? $t('validate.phone_required') : null
          ]">
          <b-input
            name="client_phone"
            icon="phone"
            :placeholder="$t('checkout.phone_placeholder')"
            v-model="model.client_phone"
            v-validate="'required|min:11'">
          </b-input>
        </b-field>
        <b-field 
          :label="$t('checkout.range_label')"
          :type="{'is-danger': errors.has('range_label')}"
          :message="[
            errors.firstByRule('range_label', 'required') ? $t('validate.required') : null,
          ]">
          <b-select placeholder="Срок" v-model="default_range" expanded @input="saveRange()">
            <option
              v-for="option in ranges"
              :value="option.id"
              :key="option.id">
              {{ option.name }} {{ $t('checkout.range') }}
            </option>
          </b-select>
        </b-field>
        <b-field 
          :label="$t('checkout.message')"
          :type="{'is-danger': errors.has('message')}"
          :message="[
            errors.firstByRule('message', 'required') ? $t('validate.required') : null,
            errors.firstByRule('message', 'min') ? $t('validate.min')+'10' : null,
          ]">
          <b-input
            v-validate="'required|min:10'"
            type="textarea"
            name="message"
            v-model="getDefaultMessage"></b-input>
        </b-field>
        <vue-recaptcha v-if="need_capcha"
          ref="recaptcha"
          @verify="onCaptchaVerified"
          @expired="onCaptchaExpired"
          size="invisible"
          :sitekey="key_capcha">
        </vue-recaptcha>
      </section>
      <footer class="modal-card-foot">
        <button class="button is-primary">{{ $t('checkout.submit') }}</button>
      </footer>
    </div>
  </form>
</template>

<script>
import Vue from 'vue'
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate, {
    events: '',
});

import VueRecaptcha from 'vue-recaptcha';

export default {
  components: {
    'vue-recaptcha': VueRecaptcha
  },
  props: {
    charts: Array
  },
  data() {
    const ranges = [
      {
        "id": 1, 
        "month": 3, 
        "name": "3"
      }
    ]
    return {
      default_range: 1,
      model: {
        client_name: '',
        client_email: '',
        client_phone: '',
        message: '',
      },
      data: [],
      ranges: ranges
    }
  },
  mounted() {
    let $this = this

    $this.charts.forEach(function (item){
      let _item = {
        id: item.index,
        name: item.name,
        range_id: 1
      }
      $this.data.push(_item)
    })

    if ($this.$store.getters.isAuthenticatedUser){
      $this.$store.dispatch('getSelfInfo').then(() => {
        let client = $this.$store.getters.getClient
        if (client.id){
          $this.model.client_name = `${client.primary_name} ${client.secondary_name}`
          $this.model.client_email = client.email
          $this.model.client_phone = client.phone
          $this.model.client_id = client.id
        }
      })
    }

    $this.$store.dispatch('getRanges')
      .then(response => {
        let data = response.data.data;
        $this.ranges = []
        data.forEach((item) => {
          $this.ranges.push(item)
        })
      })
      .catch(error => {
        $this.ranges = []
      })

    $this.default_range = $this.$store.getters.getSavedRange

  },
  computed: {
    getDefaultENCtext() {
      let $this = this
      let message = ''
      $this.data.forEach(function(item){
        let range = $this.ranges.find(range => range.id === $this.default_range)
        if (range){
          message = message + `\n${item.name},${range.name}\r`
        }
      })
      return message
    },
    getDefaultMessage: {
      get: function () {
        let $this = this
        let message = $this.$i18n.t('checkout.message_template')
        message = message + $this.getDefaultENCtext
        this.model.message = message
        return message
      },
      set: function (text) {
        this.model.message = text + this.getDefaultENCtext
      }
    },
    need_capcha () {
      return this.$store.getters.isNeedCaptcha
    },
    key_capcha () {
      return this.$store.getters.getCaptchaKey
    }
  },
  methods: {
    validateBeforeSubmit() {
      let $this = this

      if ($this.need_capcha){

        $this.$validator.validateAll().then((result) => {
          if (result) {
            $this.$refs.recaptcha.execute();
            return;
          }
          else{
            $this.$toast.open({
              message:  $this.$i18n.t('notify.form_error'),
              type: 'is-danger',
              position: 'is-bottom'
            })
          }
        });

      }
      else{

        $this.$validator.validateAll().then((result) => {
          if (result) {
            let payload = $this.model
            payload.charts = $this.getChartsForOrder()
            payload.ranges = $this.getChartsForOrderWithRange()

            $this.sendPayload(payload)
          }
          else{
            $this.$toast.open({
              message:  $this.$i18n.t('notify.form_error'),
              type: 'is-danger',
              position: 'is-bottom'
            })
          }
        })
      }
    },
    getChartsForOrder(){
      return this.data.map(item => item.id)
    },
    getChartsForOrderWithRange(){
      return this.data.map(function(item){
        return {id: item.id, range: item.range_id}
      })
    },
    saveRange(){
      this.$store.dispatch('saveRange', this.default_range)
    },
    onCaptchaVerified: function (recaptchaToken) {
      let $this = this;
      $this.$refs.recaptcha.reset();

      let payload = $this.model
      payload.charts = $this.getChartsForOrder()
      payload.ranges = $this.getChartsForOrderWithRange()
      
      payload["g-recaptcha-response"] = recaptchaToken

      $this.sendPayload(payload)
    },
    onCaptchaExpired: function () {
      this.$refs.recaptcha.reset();
    },
    sendPayload: function (payload) {
      let $this = this;
      $this.$store.dispatch('pushOrder', payload)
    }
  }
}
</script>